/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';

import Link from '../../components/Link';

export default function BlogLink(props) {
  return <Link target="_blank" rel="noopener" hasUnderline {...props} />;
}
